import React from 'react'

import "./footer.css"


import { 
  MDBFooter, 
  MDBContainer, 
  MDBRow, 
  MDBCol, 
  MDBIcon 
} 
from 'mdb-react-ui-kit';

 export default function Footer() {
  return (
    <MDBFooter bgColor='light' className='footerContainer' >
        <section className=''>
            <div className='me-5 d-none d-lg-block'>
                <span></span>
        </div>

        <div className='socials'>
            <a href='https://www.facebook.com/looseendsproject/' target="_blank" className='facebook'>
            <MDBIcon color='secondary' fab icon='facebook-f' />
            </a>
            <a href='https://www.instagram.com/thelooseendsproject/' target="_blank" className='instagram'>
            <MDBIcon color='secondary' fab icon='instagram' />
            </a>
            <a href='https://www.linkedin.com/company/looseendsproject/' target="_blank" className='linkedin'>
            <MDBIcon color='secondary' fab icon='linkedin' />
            </a>
        </div>
    </section>

    <section className='mainContainer'>
        <MDBContainer className=''>
        <MDBRow className='mt-3'>
            <MDBCol md='3' lg='4' xl='3' className=''>
            <h6 className='text-uppercase fw-bold mb-4'>
                
                Loose Ends 
            </h6>
            <p id='mainContainerText' >
            Sometimes things are left unfinished. We keep your loved ones close by completing the projects they’ve left behind.
            </p>
            </MDBCol>

            <MDBCol md='3' lg='2' xl='2' className='mx-auto mb-4'>
            <h6 className='text-uppercase fw-bold mb-4'>Useful links</h6>
            <p>
                <a href='#!' target="_blank" className='text-reset'>
                Get involed 
                </a>
            </p>
            <p>
                <a href='https://www.ravelry.com/groups/loose-ends-4' target="_blank" className='text-reset'>
                Ravelry
                </a>
            </p>
            
                <a href='#!' target="_blank" className='text-reset'>
                Help
                </a>
            
            </MDBCol>



            <MDBCol md='4' lg='3' xl='3' className='contactContailer'>
              <h6 className='text-uppercase fw-bold mb-4'>Contact</h6>
              <p>
                <MDBIcon color='secondary' icon='home' className='location' />
                Seattle, Washington 
                </p>
                <p>
                <MDBIcon color='secondary' icon='home' className='location' />
                Portland, Maine
                </p>
                <p>
                <MDBIcon color='secondary' icon='envelope' className='email' />
                    <a id='email' href="mailto: projectlooseends@gmail.com">
                    projectlooseends@gmail.com
                    </a>
                </p>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    </section>

      <div className='copywrite' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
        © 2021 Copyright:
        <a className='text-reset fw-bold' href='https://www.looseendsproject.org/' target="_blank">
        looseendsproject.org
        </a>
      </div>
    </MDBFooter>
  );
}

